import { withDependencies, named } from '@wix/thunderbolt-ioc'
import { ILogger, LoggerSymbol, SiteFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import { loadScriptTag } from '@wix/thunderbolt-commons'
import type { CustomElementComponent, IWixCustomElementComponent, WixCustomElementComponentSiteConfig } from './types'
import { name } from './symbols'
import { generateWixCodeUrl } from './utils'

type WixCustomElementComponentFactory = (
	siteConfig: WixCustomElementComponentSiteConfig,
	logger: ILogger
) => IWixCustomElementComponent

const wixCustomElementComponentFactory: WixCustomElementComponentFactory = (
	siteConfig: WixCustomElementComponentSiteConfig,
	logger: ILogger
): IWixCustomElementComponent => {
	const customElementsTagNameMap: Record<string, boolean> = {}
	const customElementsUrlMap: Record<string, boolean> = {}
	return {
		shouldLoadExternalScripts() {
			return siteConfig.shouldLoadExternalScripts
		},
		// if tag-name or script url already exist in map we do not load
		async addCustomElement(customElement: CustomElementComponent) {
			let url = customElement.url
			try {
				if (customElementsTagNameMap[customElement.tagName] || customElementsUrlMap[customElement.url]) {
					return false
				}
				if (customElement.hostedInCorvid) {
					// @ts-ignore
					await import('regenerator-runtime/runtime')
					url = generateWixCodeUrl(siteConfig.wixCodeUrl, customElement.url)
				}
				await loadScriptTag(url)
			} catch (e) {
				if (customElement.hostedInCorvid) {
					logger.captureError(new Error(`failed to load custom element corvid file with url: ${url}`), {
						tags: { feature: 'wixCustomElementComponentAPI' },
					})
				}
			}
			customElementsTagNameMap[customElement.tagName] = true
			customElementsUrlMap[url] = true
			return true
		},
	}
}

export const WixCustomElementComponentAPI = withDependencies(
	[named(SiteFeatureConfigSymbol, name), LoggerSymbol],
	wixCustomElementComponentFactory
)
